// Handle expanding of sidebar
let sidebar = document.querySelector(".sidebar-navigation");

if (sidebar) {
  sidebar.addEventListener("click", () => {
    if (!sidebar.classList.contains("open")) {
      sidebar.classList.add("open");
    } else {
      sidebar.classList.remove("open");
    }
  });
}
